module.exports = __webpack_public_path__ + "media/img/logos/2024/hallowen-f615cbb3d5a8cd6030f359eccade11f9.svg";